export type LineagePerson = {
  name: string
  role: string
  desc: string
  deceased?: boolean
  isParent: boolean
}

export const LINEAGE_DATA: Record<string, LineagePerson> = {
  'Ramon Qiu': {
    name: 'Ramon Qiu',
    role: 'Uncle',
    desc: 'Orders Expensive Things',
    isParent: true
  },
  'Ryan Brown': {
    name: 'Ryan Brown',
    role: 'Step-Father',
    desc: 'Always On The Move',
    isParent: true
  },
  'Needham Hurst': {
    name: 'Needham Hurst',
    role: 'Mother',
    desc: 'Tarot Reading Burrito Eating',
    isParent: true
  },
  'Michael Wong': {
    name: 'Michael Wong',
    role: 'Father',
    desc: 'Karaoke & Gadget Obsessed',
    isParent: true
  },
  'Andrew Winter': {
    name: 'Andrew Winter',
    role: 'Step-Mother',
    desc: 'Weekly Skiing Sweetgreen Loyalist',
    deceased: true,
    isParent: true
  },
  'Melanie Rothman': {
    name: 'Melanie Rothman',
    role: 'Aunt',
    desc: 'Sweet But Needs to Move Back to NY',
    isParent: true
  },
  'Benedict Wong': {
    name: 'Benedict Wong',
    role: 'Uncle',
    desc: 'Always Screaming on His Phone Motorcyclist',
    isParent: true
  },
  'Kevin Yan': {
    name: 'Kevin Yan',
    role: 'Older Brother',
    desc: 'We All Rely On Him',
    isParent: false
  },
  'Jilliane Avila': {
    name: 'Jilliane Avila',
    role: 'Middle Sister',
    desc: 'Organized Joe & the Juice Addict',
    deceased: true,
    isParent: false
  },
  'Thomas Asnake': {
    name: 'Thomas Asnake',
    role: 'Middle Brother',
    desc: 'Can Sweet Talk Anyone',
    isParent: false
  },
  'Jocelyn Thai': {
    name: 'Jocelyn Thai',
    role: 'Older Twin Sister',
    desc: 'Night Owl Hacker',
    deceased: true,
    isParent: false
  },
  'Serra Kocoglu': {
    name: 'Serra Kocoglu',
    role: 'Younger Twin Sister',
    desc: 'Early Bird Finance',
    isParent: false
  },
  'Kai Lin Hii': {
    name: 'Kai Lin Hii',
    role: 'Cousin',
    desc: 'Brings Us Sweets',
    deceased: true,
    isParent: false
  },
  'Alex Medina': {
    name: 'Alex Medina',
    role: 'TBA',
    desc: 'TBA',
    isParent: false
  },
  'Lindsey Tully': {
    name: 'Lindsey Tully',
    role: 'TBA',
    desc: 'TBA',
    isParent: false
  }
}
